<template>
    <el-drawer v-model="localVisible" title="仅供组内交流学习!" :with-header="false" direction="rtl" :size="drawerSize"
        :before-close="handleClose" class="mobile-drawer" :class="{ 'is-mobile': isMobile }">
        
        <!-- 自定义头部 -->
        <div class="drawer-header">
            <el-text class="header-title" type="danger" size="large">功能版本说明</el-text>
            <el-text class="header-subtitle" type="info" size="small">仅供组内交流学习</el-text>
        </div>

        <!-- 移动端卡片视图 -->
        <div v-if="isMobile" class="mobile-card-container">
            <div v-for="item in gridData" :key="item.func" class="func-card">
                <div class="card-header">
                    <el-tag size="small" type="danger" effect="light" class="func-tag">功能 {{ item.func }}</el-tag>
                    <el-tag size="small" :type="getVersionType(item.ver)" effect="plain">{{ item.ver }}</el-tag>
                </div>
                <div class="card-body">
                    <p class="func-desc" :class="{ 'is-disabled-desc': item.desc.includes('停用') }">{{ item.desc }}</p>
                </div>
            </div>
        </div>

        <!-- 桌面端表格视图 -->
        <el-table v-else :data="gridData" class="desktop-table">
            <el-table-column property="func" label="类型" width="60" />
            <el-table-column property="ver" label="起始版本" width="80" />
            <el-table-column property="desc" label="功能描述">
                <template #default="{ row }">
                    <span :class="{ 'is-disabled-desc': row.desc.includes('停用') }">{{ row.desc }}</span>
                </template>
            </el-table-column>
        </el-table>
    </el-drawer>
</template>

<script>
import { ref, watch, computed, onMounted, onUnmounted } from 'vue';

export default {
    props: {
        modelValue: {
            type: Boolean
        }
    },
    setup(props, { emit }) {
        const gridData = [
            {
                func: '32',
                ver: 'V50.75',
                desc: '下发自定义的灵活配置',
            },
            {
                func: '30',
                ver: 'v50.60',
                desc: '在线车型数据收集：V50.60 版本存在数据收集 Bug，实际需按 V50.70 及以上版本进行收集',
            },
            {
                func: '29',
                ver: 'v50.50',
                desc: '下发随机密钥加密版本的在线功能配置',
            },
            {
                func: '28',
                ver: 'v50.40',
                desc: '查询so是否需要在线更新',
            },
            {
                func: '27',
                ver: 'IMMO-调试',
                desc: '获取防盗快捷版VIN数据',
            },
            {
                func: '26',
                ver: 'IMMO-v11.10',
                desc: '防盗软件收集outcode-incode数据',
            },
            {
                func: '25',
                ver: 'IMMO-v10.90',
                desc: '防盗软件808模式相关安全校验',
            },
            {
                func: '24',
                ver: 'v50.10',
                desc: '提取特殊功能参数 键盘代码(Keypad Code Programming) - 新增数据需调用爬虫',
            },
            {
                func: '23',
                ver: 'v50.10',
                desc: '根据Vin,确定走在线车型,离线车型,JMC车型',
            },
            {
                func: '22',
                ver: 'v50.10',
                desc: '根据Vin,返回特征码模板 - 配合模版识别车型使用',
            },
            {
                func: '21',
                ver: 'v50.10',
                desc: '下发FDRS故障码(GDS,GGDS,JMC,VW)文本到诊断中,支持多语言',
            },
            {
                func: '20',
                ver: 'v49.90',
                desc: '发送多语言版本提示文本 - 在V50.10版本以及后续版本中停用',
            },
            {
                func: '19',
                ver: 'v50.10',
                desc: '根据VIN下发在线功能文件 -- 包含爬虫,模版,压缩文件,发送邮件,自动化整理deliver和Features等操作',
            },
            {
                func: '18',
                ver: 'v49.90',
                desc: '根据VIN和诊断版本,给2010-2022年非原厂PCM软件号的情况返回匹配的VQ',
            },
            {
                func: '17',
                ver: 'v49.90',
                desc: 'Deliv文件匹配发动机MDX,并返回离线库相似车系ID,在V50.10版本以及后续版本中停用',
            },
            {
                func: '16',
                ver: 'v49.90',
                desc: 'IDS : 离合器电磁阀IDN识别 - 需在站点上传数据',
            },
            {
                func: '15',
                ver: 'v49.90',
                desc: 'CANFD试探接口',
            },
            {
                func: '12',
                ver: 'v49.90',
                desc: '获取在线车型可编程模块安装数据 - 需配合爬虫处理',
            },
            {
                func: '11',
                ver: 'v49.50',
                desc: '测试客户端网络连通情况',
            },
            {
                func: '10',
                ver: 'v49.70',
                desc: '通过VIN查询Deliver,在V50.10版本以及后续版本中停用',
            },
            {
                func: '7',
                ver: 'v49.60',
                desc: '在线特殊功能配置,在V50.10版本以及后续版本中停用',
            },
            {
                func: '5',
                ver: 'v49.60',
                desc: 'FDRS FORD,VW:16V16,JMC:4V4,FORD:兼容部分 3V3',
            },
            {
                func: '3',
                ver: 'v49.50',
                desc: 'PATS自动计算，仅适用经典福克斯,老款蒙迪欧',
            },
            {
                func: '2',
                ver: 'v49.50',
                desc: 'Ford 2017年后VIN数据手机,在V50.10版本以及后续版本中停用',
            },
            {
                func: '1',
                ver: 'v49.50',
                desc: 'IDS 16V16',
            },
        ];

        // 响应式判断手机端
        const isMobile = ref(window.innerWidth <= 768);
        
        const handleResize = () => {
            isMobile.value = window.innerWidth <= 768;
        };

        onMounted(() => {
            window.addEventListener('resize', handleResize);
        });

        onUnmounted(() => {
            window.removeEventListener('resize', handleResize);
        });

        // 根据屏幕尺寸动态设置抽屉宽度
        const drawerSize = computed(() => {
            return isMobile.value ? '90%' : '50%';
        });

        // 本地响应式变量来控制抽屉的显示状态  
        const localVisible = ref(props.modelValue);

        // 监听 props.visible 的变化，并更新 localVisible  
        watch(() => props.modelValue, (newValue) => {
            localVisible.value = newValue;
        });

        // 处理抽屉关闭事件  
        const handleClose = (done) => {
            emit('update:modelValue', false);
            done();
        };

        // 根据版本号获取标签类型
        const getVersionType = (ver) => {
            const normalizedVer = ver.toLowerCase();
            if (ver.includes('IMMO')) return 'warning';
            if (normalizedVer.includes('v50.7')) return 'danger';
            if (normalizedVer.includes('v50.6')) return 'danger';
            if (normalizedVer.includes('v50.5')) return 'success';
            if (normalizedVer.includes('v50.4')) return 'info';
            if (normalizedVer.includes('v50.1')) return 'primary';
            return '';
        };

        return {
            localVisible,
            handleClose,
            gridData,
            isMobile,
            drawerSize,
            getVersionType
        };
    }
};
</script>

<style scoped>
/* 基础样式 */
.drawer-header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 16px;
}

.header-title {
    display: block;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 4px;
}

.header-subtitle {
    display: block;
    font-size: 12px;
    color: #909399;
}

/* 桌面端表格样式 */
.desktop-table {
    width: 100%;
}

.is-disabled-desc {
    color: #909399;
    text-decoration: line-through;
    text-decoration-thickness: 1.5px;
}

/* 移动端样式 */
@media screen and (max-width: 768px) {
    .mobile-drawer.is-mobile {
        /* 确保抽屉内容可以滚动 */
        :deep(.el-drawer__body) {
            padding: 0;
            overflow-y: auto;
            background-color: #f5f7fa;
        }
    }

    .mobile-card-container {
        padding: 12px;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .func-card {
        background: #ffffff;
        border-radius: 12px;
        padding: 14px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        transition: transform 0.2s ease;
        border: 1px solid #f0f2f5;
    }

    .func-card:active {
        transform: scale(0.99);
    }

    .card-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 10px;
        flex-wrap: wrap;
    }

    .func-tag {
        font-weight: 500;
        background-color: #fef0f0;
        border-color: #fbc4c4;
        color: #f56c6c;
    }

    .card-body {
        padding-left: 4px;
    }

    .func-desc {
        margin: 0;
        font-size: 14px;
        line-height: 1.5;
        color: #303133;
        word-break: break-word;
    }

    /* 抽屉头部在移动端的调整 */
    .drawer-header {
        padding: 16px 16px 12px;
        background-color: #ffffff;
        margin-bottom: 0;
        border-bottom: 1px solid #f0f2f5;
    }

    .header-title {
        font-size: 16px;
    }

    .header-subtitle {
        font-size: 12px;
    }
}

/* 桌面端保留原样 */
@media screen and (min-width: 769px) {
    .mobile-card-container {
        display: none;
    }
    
    .drawer-header {
        padding: 16px 20px 8px;
    }
}

/* 覆盖element-plus默认样式 */
:deep(.el-drawer__header) {
    display: none;
}

:deep(.el-drawer__body) {
    padding: 0;
    overflow: auto;
}

/* 美化滚动条 */
:deep(.el-drawer__body)::-webkit-scrollbar {
    width: 6px;
}

:deep(.el-drawer__body)::-webkit-scrollbar-thumb {
    background: #dcdfe6;
    border-radius: 3px;
}

:deep(.el-drawer__body)::-webkit-scrollbar-track {
    background: #f5f7fa;
}
</style>
